const REGION_CONFIGS = {
  AMER: {
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID_AMER,
    issuer: process.env.REACT_APP_OKTA_ISSUER_AMER,
  },
  EMEA: {
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID_EMEA,
    issuer: process.env.REACT_APP_OKTA_ISSUER_EMEA,
  },
  APAC: {
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID_APAC,
    issuer: process.env.REACT_APP_OKTA_ISSUER_APAC,
  },
};

export const SUPPORTED_REGIONS = Object.keys(REGION_CONFIGS);

export const getSelectedRegion = () =>
  localStorage.getItem('okta_region') || 'AMER';

export const setSelectedRegion = (region) => {
  localStorage.setItem('okta_region', region);
};

export const oktaConfig = (() => {
  const region = getSelectedRegion();
  const { clientId, issuer } = REGION_CONFIGS[region] || REGION_CONFIGS.AMER;
  return {
    clientId,
    issuer,
    redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI || `${window.location.origin}/callback`,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    disableHttpsCheck: process.env.NODE_ENV === 'development',
    tokenManager: {
      autoRenew: true,
      expireEarlySeconds: 120,
    },
    session: {
      maxAge: 7200, // 2 hours — matches Guidewire Okta session lifetime
    },
  };
})();

export const isOktaConfigured = () =>
  Boolean(oktaConfig.clientId && oktaConfig.issuer);

export const getOktaConfigErrors = () => {
  const errors = [];
  if (!oktaConfig.clientId) errors.push('OKTA Client ID is not configured');
  if (!oktaConfig.issuer) errors.push('OKTA Issuer is not configured');
  return errors;
};
